<template>
  <jw-tooltip>
    <div class="comp-computed-tips"></div>
    <template #content>
      <div :style="{ display: 'flex', 'flex-wrap': 'wrap' }" class="computed-error">
        <!-- 审批异常 --->
        <!-- 计算异常 --->
        <template v-if="computedError.length">
          <div class="tips-inner">
            存在公式计算异常,
            <span v-for="(item, index) in computedError" :key="index">
              <template v-if="item.fieldName"> 【{{ item.fieldName }}】 </template>
              <template v-else>
                {{ item.tipMsg }}
              </template>
            </span>
          </div>
        </template>
        <template v-if="approveError.length">
          <div class="tips-inner">
            审批错误:
            <span v-for="(item, index) in approveError" :key="index">
              {{ item.tipMsg }}
            </span>
          </div>
        </template>
      </div>
    </template>
  </jw-tooltip>
</template>

<script setup>
import { computed } from 'vue';
console.log('1-开始创建组件-setup');
const props = defineProps({
  computedInfo: {
    type: Object
  },
  fieldList: {
    type: Array
  },
  success: {
    type: Boolean
  },
  hasChild: {
    /* 主表是否含有分组 */
    type: Boolean
  }
});
console.log('计算字段头部提示', props);
const approveError = computed(() => {
  return props.computedInfo?.computeFieldErrors?.filter((fItem) => fItem.opType === 2); // 审批错误
});
const computedError = computed(() => {
  return props.computedInfo?.computeFieldErrors?.filter((fItem) => fItem.opType === 1); // 计算错误
});
</script>
<style scoped lang="less">
@import './computed-tips.less';
</style>
